import React, { useEffect, useState } from 'react';

export default function Loader({ onDone }) {
  const [done, setDone] = useState(false);
  useEffect(() => {
    // Total visible duration ~ 1.8s
    const t1 = setTimeout(() => setDone(true), 1800);
    const t2 = setTimeout(() => onDone && onDone(), 2400);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div className={`fixed inset-0 z-[100] bg-white flex items-center justify-center transition-all duration-700 ${done ? 'opacity-0 -translate-y-4 pointer-events-none' : 'opacity-100'}`}>
      <div className="absolute inset-0 grid-bg opacity-25 pointer-events-none"/>
      <div className="absolute -top-40 -left-40 w-[420px] h-[420px] rounded-full bg-[#2596BE]/8 blur-3xl"/>
      <div className="absolute -bottom-40 -right-40 w-[420px] h-[420px] rounded-full bg-[#F3763A]/8 blur-3xl"/>
      <div className="relative flex flex-col items-center">
        <img src="/logos/full.png" alt="Tricolite Energy Solutions" className="h-16 md:h-24 w-auto floaty select-none" />
      </div>
    </div>
  );
}
